module.exports = __webpack_public_path__ + "img/03.4fa345e1.jpg";